import React, { useEffect, useState } from 'react';
import TimeLimitReachedModal from '../../wedding-wardrobe/src/components/base/TimeLimitReachedModal';
import { formattedDate } from './parser';
import Clock from '../../booking-system/appointment-booking/src/images/Clock.svg';

export default ({ offset, statusTimestamp, gid }) => {
  const timeDiff = +new Date(new Date(formattedDate(statusTimestamp)).getTime() + offset * 60000) - +new Date();
  const calculateTimeLeft = () => {
    let timeLeft = {};
    if (timeDiff > 0) {
      timeLeft = {
        minutes: Math.floor((timeDiff / 1000 / 60) % 60),
        seconds: Math.floor((timeDiff / 1000) % 60),
      };
    }

    return timeLeft;
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
     setTimeout(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);
  });

  return (
    <div className="countdown-timer">
      {timeLeft.minutes || timeLeft.seconds
        ? (
          <p>
            <img src={Clock} alt="Clock" />
            Please confirm your booking within <span className="timer">{timeLeft.minutes}:{(`0${timeLeft.seconds}`).toString().slice(-2)}</span> minutes
          </p>
        )
        : (
          <TimeLimitReachedModal
            confirmationLabel="You reached the time limit for reservation, you will be sent back to select a new time slot."
            gid={gid}
          />
        )}
    </div>
  );
};
